import * as Yup from 'yup';
import { TFunction } from 'react-i18next';
import { DbsSettings } from 'models/DbsSettings';

export const COLOR_FIELDS = [
  'headlineColor',
  'primaryColor',
  'secondaryColor',
] as const;

export type ColorField = (typeof COLOR_FIELDS)[number];

export type ColorSettingsFormValues = {
  [_key in ColorField]: string;
};

// The design shows the hash both as a prefix and in the value, so the field keeps it
// and typing it is optional.
const HEX_COLOR_PATTERN = /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

const FALLBACK_SWATCH_COLOR = '#000000';

export const toApiColor = (value: string) => {
  const hex = value.replace('#', '');

  return `#${
    hex.length === 3
      ? hex
          .split('')
          .map((digit) => `${digit}${digit}`)
          .join('')
      : hex
  }`;
};

export const toSwatchValue = (value: string) =>
  HEX_COLOR_PATTERN.test(value) ? toApiColor(value) : FALLBACK_SWATCH_COLOR;

export const getColorSettingsDefaultValues = (
  dbsSettings?: DbsSettings,
): ColorSettingsFormValues => ({
  headlineColor: dbsSettings?.headlineColor ?? '',
  primaryColor: dbsSettings?.primaryColor ?? '',
  secondaryColor: dbsSettings?.secondaryColor ?? '',
});

export const getColorSettingsSchema = (t: TFunction) => {
  const hexColor = Yup.string().matches(HEX_COLOR_PATTERN, {
    excludeEmptyString: true,
    message: t('pageDirectBookingEngine.colorSettings.invalidColor'),
  });

  return {
    headlineColor: hexColor,
    primaryColor: hexColor,
    secondaryColor: hexColor,
  };
};
